import React from 'react';
import { DEFAULT_SSO_DATA, SsoData, SsoDataContext } from './context';
import { useLocation } from 'react-router';

const SsoDataProvider: React.FC<React.PropsWithChildren<Record<never, any>>> = ({ children }) => {
  const location = useLocation();
  const [ssoData, setSsoData] = React.useState<SsoData>(DEFAULT_SSO_DATA);

  React.useEffect(() => {
    setSsoData((current) => ({
      ...current,
      ssoIdentityProviderUid: null,
    }));
  }, [location]);

  return <SsoDataContext.Provider value={{ ssoData, setSsoData }}>{children}</SsoDataContext.Provider>;
};

export default SsoDataProvider;
